var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.pivotData)?_c('pivot-table-component',{staticClass:"table-responsive pb-4 pr-4",attrs:{"pivotData":_vm.pivotData,"aggregator-name":_vm.aggregatorName,"renderer-name":_vm.rendererName}}):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }